import { LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>Do you have?</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="About Us" keyName={LocationVarKey.HasAboutURL} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Account Login"
            keyName={LocationVarKey.HasAccountLoginPage}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Auctions" keyName={LocationVarKey.HasAuctions} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Careers" keyName={LocationVarKey.HasCareerURL} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Franchise" keyName={LocationVarKey.HasFranchise} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Insurance Info"
            keyName={LocationVarKey.HasInsuranceWebsiteURL}
          />
          <WorksheetComponent
          componentType={WorksheetComponentType.SWITCH}
          {...page}
          label="Mobile App"
          keyName={LocationVarKey.HasMobileApp}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Moving Services"
            keyName={LocationVarKey.HasMovingServices}
          />
        </WorksheetColumn>

        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Packing Supplies"
            keyName={LocationVarKey.HasPackingSupplies}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Pay By Phone" keyName={LocationVarKey.HasPayByPhone} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Pay Online" keyName={LocationVarKey.HasPayOnlineURL} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Privacy Policy"
            keyName={LocationVarKey.HasPrivacyPolicyURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Recycle Program"
            keyName={LocationVarKey.HasRecycleProgram}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Referral Program"
            keyName={LocationVarKey.HasReferralProgram}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Size Guide" keyName={LocationVarKey.HasSizeGuideURL} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Shred Program"
            keyName={LocationVarKey.HasShredProgram}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <h4>Important URLs</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="About Us"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasAboutURL, "1")}
            keyName={LocationVarKey.AboutStorageCompanyURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Account Login"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}
            keyName={LocationVarKey.AccountLoginURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Auctions"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1")}
            keyName={LocationVarKey.AuctionsURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Careers"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1")}
            keyName={LocationVarKey.CareersURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Google Review"
            keyName={LocationVarKey.GoogleReviewURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Insurance Info"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasInsuranceWebsiteURL, "1")}
            keyName={LocationVarKey.InsuranceURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Mobile App Download"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasMobileApp, "1")}
            keyName={LocationVarKey.MobileAppDownloadURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Moving Services"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasMovingServices, "1")}
            keyName={LocationVarKey.MovingServicesURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Packing Supplies"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasPackingSupplies, "1")}
            keyName={LocationVarKey.PackingSuppliesURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Pay Online Login"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasPayOnlineURL, "1")}
            keyName={LocationVarKey.PayOnlineURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Location Specific Payment Portal"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasPayOnlineURL, "1")}
            keyName={LocationVarKey.PaymentURL}
          />

          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Privacy Policy"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasPrivacyPolicyURL, "1")}
            keyName={LocationVarKey.PrivacyPolicyURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Recycle Program"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasRecycleProgram, "1")}
            keyName={LocationVarKey.RecycleURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Referral Program"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasReferralProgram, "1")}
            keyName={LocationVarKey.ReferralProgramURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Shred Program"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasShredProgram, "1")}
            keyName={LocationVarKey.ShredURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Size Visuals"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasSizeGuideURL, "1")}
            keyName={LocationVarKey.SizeVisualsURL}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
